<template>
  <div class="progress-section d-flex align-items-center w-100">
    <span class="label mr-3">課程目標</span>

    <div class="progress-wrapper position-relative flex-grow-1">
      <div class="progress custom-progress">
        <div 
          class="progress-bar" 
          :style="{ width: (number / maxNumber) * 100 + '%' }"
        ></div>
      </div>
      <div  class="complete-overlay" v-if="number >= maxNumber">
        <button class="btn btn-complete rounded-pill" @click="showResult">
          目標完成，點我送出紀錄
        </button>
      </div>
    </div>

    <span class="counter ml-3">{{ number }}/{{ maxNumber }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Chart from 'chart.js'
export default {
  name: 'ProgressBar',
  props: {
    pass_score: {
      type: Number,
      default: 70
    },
    maxNumber: {
      type: Number,
      default: 5
    },
    number: {
      type: Number,
      default: 0
    },
    ers_avg: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    showResult () {
      if (typeof Chart === 'undefined') {
        console.error("找不到 Chart.js，請確認是否已正確引入套件！");
        this.$swal("錯誤", "圖表套件載入失敗", "error");
        return;
      }
      this.$swal({
        width: '600px',
        padding: '0',
        showCloseButton: true,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: '繼續對話',
        customClass: {
          popup: 'rounded-lg overflow-hidden',
          actions: 'my-3',
          closeButton: 'top-0 right-0 z-2',
          cancelButton: 'btn btn-outline-danger px-5 rounded'
        },
        html: `
          <div class="result-header text-center row" style="background-color: #ffd966; position: relative;">
            <div class="col"><img src="${require('@/assets/image/ai/course/robot_progress.png')}" alt="robot"></div>
            <div class="col d-flex align-items-center">
              <div class="bg-white rounded shadow-sm d-inline-block px-4 py-2 mt-2" style="min-width: 140px;">
                <div style="font-size: 14px; color: #333; font-weight: bold;">Score</div>
                <div style="font-size: 48px; font-weight: bold; line-height: 1;">${this.ers_avg.PronScore}</div>
              </div>
            </div>

          </div>
          <div class="p-4 bg-white pt-5" style="position: relative;">
            <div style="width: 400px; height: 400px; margin: 0 auto;">
              <canvas id="resultChart"></canvas>
            </div>
          </div>
        `,
        didOpen: () => {
          setTimeout(() => {
            const canvas = document.getElementById('resultChart');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');

            new Chart(ctx, {
              type: 'radar',
              data: {
                labels: ['平均分數', '準確度', '流暢度', '完整性', '韻律'],
                datasets: [{
                  label: 'Score',
                  data: [this.ers_avg.PronScore, this.ers_avg.AccuracyScore, this.ers_avg.FluencyScore, this.ers_avg.CompletenessScore, this.ers_avg.ProsodyScore],
                  backgroundColor: 'rgba(180, 185, 210, 0.5)', // 圖中那種灰藍色填充
                  borderColor: '#b4b9d2',
                  pointBackgroundColor: '#b4b9d2',
                  borderWidth: 1,
                  pointRadius: 0 // 隱藏節點圓點
                }]
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { 
                  display: false
                },
                scale: { // 🌟 關鍵修正：這裡必須是單數的 scale，不是 scales
                  pointLabels: {
                    fontSize: 20,         // 改大字體才會正式生效 (建議 20~24 之間)
                    fontColor: '#000000', // 文字顏色
                    fontStyle: 'bold'     // 粗體
                  },
                  angleLines: {
                    color: '#e0e0e0'
                  },
                  gridLines: {
                    color: '#e0e0e0'
                  },
                  ticks: {
                    display: false, // 隱藏一圈一圈的數字
                    min: 0,
                    max: 100,
                    stepSize: 10
                  }
                }
              }
            });
          }, 100); // 給 100ms 的延遲，確保 canvas 標籤已存在
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
/* 進度條樣式 */
.custom-progress {
  height: 14px !important;
  background: transparent !important;
  border: 1.5px solid #5d669b;
  border-radius: 10px;
}
.custom-progress .progress-bar {
  background-color: #5d669b;
  border-radius: 10px;
}

/* 完成狀態的覆蓋按鈕 */
.complete-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.btn-complete {
  background-color: #5d669b;
  color: white;
  border: 2px solid white;
  padding: 5px 20px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

/* 導師選中紅框 (image_dc4cde) */
.mentor-item.active {
  border: 2px solid #e5413c !important; /* 紅色外框 */
  box-shadow: 0 0 10px rgba(229, 65, 60, 0.2);
}

/* 彈窗紅色標題 */
.mentor-swal-header {
  background-color: #e5413c !important;
}
</style>
